import { render, staticRenderFns } from "./Skippage.vue?vue&type=template&id=0d10c6c2&scoped=true&"
import script from "./Skippage.vue?vue&type=script&lang=js&"
export * from "./Skippage.vue?vue&type=script&lang=js&"
import style0 from "./Skippage.vue?vue&type=style&index=0&id=0d10c6c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d10c6c2",
  null
  
)

export default component.exports